export default function Computer(props: any) {
    return (
        <svg width="56" height="57" viewBox="0 0 56 57" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_3929_5278)">
                <path
                    d="M6 40.5702V11.6395C6 10.3076 7.03715 9.22754 8.31687 9.22754H47.6862C48.966 9.22754 50.0031 10.3076 50.0031 11.6395V40.5702"
                    stroke="black"
                    strokeWidth="2.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M52.6988 46.9194H3.30569C2.87565 46.9194 2.52734 46.5569 2.52734 46.1093L5.62294 40.7225H49.6852L53.4772 46.1093C53.4772 46.5569 53.1289 46.9194 52.6988 46.9194Z"
                    stroke="black"
                    strokeWidth="2.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M26.8867 12.0645H29.114" stroke="black" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_3929_5278">
                    <rect width="56" height="56" fill="white" transform="translate(0 0.0732422)" />
                </clipPath>
            </defs>
        </svg>
    );
}
